import styled from 'styled-components';
import { primary, white } from 'styles/colorProvider';

export const Container = styled.div`
  background-color: ${white};
  width: 100%;
  height: 100% !important;
  max-height: 100% !important;
  overflow-y: hidden !important;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const ContentArea = styled.div`
  display: flex;
  align-items: left;
  flex-direction: column;
  width: 90%;
  height: 100% !important;
  max-height: 100% !important;
  box-sizing: border-box;
  padding: 30px;
  padding-left: 90px;
  position: relative;

  @media (max-width: 1000px) {
    width: 100%;
    padding-left: 20px;
  }
`;

export const Title = styled.h1`
  font-size: 28px;
  color: ${primary};
  margin-bottom: 10px;

  @media (max-width: 1000px) {
    margin: 20px 0px;
  }
`;

export const Div = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .containerTitle {
    display: flex;
    width: 40%;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;

    @media (max-width: 1000px) {
      width: 100%;
    }
  }

  @media (max-width: 1000px) {
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
`;

export const SearchRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  margin-top: 15px;
`;

export const ClientCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 20px;
  padding: 15px;
  border-radius: 6px;
  background-color: #fafafa;

  h3 {
    margin: 0 0 4px 0;
  }

  span {
    font-size: 13px;
    color: #666;
  }
`;

export const TableArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 20px;
  padding-bottom: 30px;

  p {
    font-weight: bold;
    margin-bottom: 5px;
  }
`;

export const GroupPanel = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 25px;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 6px;

  h3 {
    margin-top: 0;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
`;
